module.exports = __webpack_public_path__ + "static/media/SmallCrop.c2e2b1f8.svg";